import React from 'react';
import ReactStars from "react-rating-stars-component";
import {useTranslation} from 'react-i18next';


 const VideoRating = ({w}) => {

     const {t} = useTranslation();

    return (<>
                <ReactStars
                    classNames={"HoverRating"}
                    value={w.score}
                    edit={false}
                    size={20}
                    color={"rgb(255, 157, 10)"}
                    activeColor={"rgb(255, 157, 10)"}
                    emptyIcon={<ion-icon name="star-outline" aria-label={t('rating.empty.star')}/>}
                    halfIcon={<ion-icon name="star-half" aria-label={t('rating.half.star')}/>}
                    filledIcon={<ion-icon name="star" aria-label={t('rating.filled.star')}/>}
                    isHalf={false}
                />
                {<div>
                    {w?.score && w?.score !== 0 ?
                        <p className={"HoverRatingScore"}>{w.score}</p> :
                        <p style={{fontSize: "10px"}}
                           className={"HoverRatingScore"}>{t('playlist.rating')}</p>}
                </div>}

    </>)
}

export default VideoRating;
